import { render, staticRenderFns } from "./PublicFiles.vue?vue&type=template&id=5464ce74&scoped=true&"
import script from "./PublicFiles.vue?vue&type=script&lang=js&"
export * from "./PublicFiles.vue?vue&type=script&lang=js&"
import style0 from "./PublicFiles.vue?vue&type=style&index=0&id=5464ce74&prod&lang=scss&"
import style1 from "./PublicFiles.vue?vue&type=style&index=1&id=5464ce74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464ce74",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
